// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Form from '../../ui/components/Forms/ForgotPassword/SetNewPassword';
import { setNewPassword, closeModal, setForm } from '../../actions';
import { LOGIN_FORM } from '../../constants/forms';

type Props = {
    auth: {
        isLoadingButton: boolean,
    },
    branding: Object,
    params: Object,
    setNewPassword: Function,
    closeModal: Function,
    setForm: Function,
};

type State = {
    name: string,
    active: boolean,
};

export class SetNewPassword extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            active: false,
        };
    }

    closeModal = () => {
        this.props.closeModal();
    };

    changeForm = (form: any) => {
        return (e: Object) => {
            if (e) e.preventDefault();
            this.props.setForm(form);
        };
    };

    setNewPassword = (data: Object) => {
        if (this.props.auth.isLoadingButton) return;

        this.props.setNewPassword(
            data.newpassword,
            data.repassword,
            data.token,
            this.changeForm(LOGIN_FORM)
        );
    };

    handleFocus = e => {
        e.preventDefault();
        this.setState({
            name: e.target.name,
            active: !this.state.active,
        });
    };

    render() {
        const { branding, params } = this.props;

        return (
            <Form
                auth={this.props.auth}
                onSubmit={this.setNewPassword}
                closeModal={this.closeModal}
                changeForm={this.changeForm}
                branding={branding}
                params={params}
                handleFocus={this.handleFocus}
                active={this.state.active}
                name={this.state.name}
            />
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        auth: state.auth,
        branding: state.branding,
        params: state.form.newPasswordForm,
    };
};

export default connect(
    mapStateToProps,
    {
        setNewPassword,
        closeModal,
        setForm,
    }
)(SetNewPassword);



// WEBPACK FOOTER //
// ./src/containers/Forms/SetNewPassword.js